import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { apiInstanceV2 } from '../../Apis/AxiosV2';
import { createImgObj, getSelfie } from '../CompanyEmployees/CompanyEmployeesApi';
import {accessMethodModel} from "../../enums/accessMethodEnum";
import { DOCUMENT_SERVICE,  ORDER_SERVICE,  SUPPLIER_SERVICE, } from "../EndPoints";
import { UploadImage } from '../ShareSlice/shareApi';
import { TABLES } from '../../Apis/Tables';
//   @create order flow start




// create purshase order  (supplier-module order-controller) (done)
export const CreateSupplierOrder = createAsyncThunk(
    'employeeProvider/createSupplierOrder',
    async (params) => {
        const result = await apiInstance
            .post(ORDER_SERVICE.createSupplierOrder, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const EmployeeFlowUpdateOrder = createAsyncThunk(
    'employeeProvider/employeeFlowUpdateOrder',
    async (params) => {
        const result = await apiInstance
            .put(ORDER_SERVICE.employeeFlowUpdateOrder, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


// see detials order  (provider-module order-controller)  (done  (but need to fix status))
export const GetSupplierOrder = createAsyncThunk(
    'employeeProvider/getSupplierOrder',
    async (params) => {
        const result = await apiInstanceV2
            .get(`${ORDER_SERVICE.getSupplierOrder}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


// Get list of provider (done)
export const GetEmployeeProviderLists = createAsyncThunk(
    'employeeProvider/getEmployeeProviderLists',
    async () => {
        const result = await apiInstanceV2
            .get(SUPPLIER_SERVICE.getEmployeeProviderLists)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


// get list of gender
export const GetGenderListProvider = createAsyncThunk(
    'employeeProvider/getGnderListProvider',
    async () => {
        const result = await apiInstance
            .get('gender-service/get-all')
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);


// /corporate-user-pre-prod-v1/document-service/approve-external-document (done)
export const ApproveExternalDocument = createAsyncThunk(
    'employeeProvider/approveExternalDocument',
    async (params) => {
        const result = await apiInstance
            .post(DOCUMENT_SERVICE.approveExternalDocument, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// get user docs
export const GetUserDocumentsEmployee = createAsyncThunk(
    'employeeProvider/getUserDocumentsEmployee',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`${DOCUMENT_SERVICE.getUserDocumentsEmployee}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);


// create document employee value
export const CreateToExternalEmployee = createAsyncThunk(
    'employeeProvider/createToExternalEmployee',
    async (params) => {
        const result = await apiInstance
            .post(DOCUMENT_SERVICE.createToExternalEmployee, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);


//  create supplier Employee
export const CreateEmployeeSupplier = createAsyncThunk(
    'employeeProvider/createEmployeeSupplier',
    async (params, { dispatch }) => {
        const result = await apiInstance
            .post(SUPPLIER_SERVICE.createEmployeeSupplier, params?.data)
            .then(async function (response) {
                const imgData = {
                    user: {
                        id: response?.data?.data?.userId,
                    },
                    accessMethod: { id: accessMethodModel.FACE_RECOGNITION.id },
                    description: 'Face recognition',
                };
                // want to update or create image
                if (params?.file !== '' && params?.file != null) {
                    const {
                        payload: { data: { data, success } = {} } = {},
                    } = await dispatch(
                        createImgObj({
                            ...imgData,
                            file: params.file,
                        }),
                    );
                    if (success) {
                        let formData = new FormData();

                        formData.append('id', data.id);
                        formData.append('option', TABLES.USER);
                        formData.append('file', params?.file);

                        await dispatch(UploadImage(formData));
                    }
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
//  get supplier data by it id
export const GetEmployeeSupplierByItId = createAsyncThunk(
    'employeeProvider/getEmployeeSupplierByItId',
    async (params) => {
        const result = await apiInstance
            .get(`${SUPPLIER_SERVICE.getEmployeeSupplierByItId}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

//  update supplier employee
export const UpdateSupplier = createAsyncThunk(
    'employeeProvider/updateSupplier',
    async (params, { dispatch }) => {
        const { data, file, updateImage, setModified } = params;

        try {
            const response = await apiInstance.put(
                SUPPLIER_SERVICE.updateSupplier,
                data,
            );

            const userId = response?.data?.data?.userId;

            const imgData = {
                user: { id: userId },
                accessMethod: { id: accessMethodModel.FACE_RECOGNITION.id },
                description: 'Face recognition',
            };

            if (file) {
                let imageId = updateImage
                    ? (await dispatch(getSelfie(userId)).unwrap())?.data?.data?.id
                    : null;

                // No previous selfie: create the user image object to get its id
                if (!imageId) {
                    const {
                        payload: { data: { data: createdImg, success: imgSuccess } = {} } = {},
                    } = await dispatch(createImgObj({ ...imgData, file }));

                    if (imgSuccess) imageId = createdImg?.id;
                }

                if (imageId) {
                    const formData = new FormData();
                    formData.append('id', imageId);
                    formData.append('file', file);
                    formData.append('option', TABLES.USER);

                    await dispatch(UploadImage(formData));
                }
            }

            setModified?.(true);

            return {
                data: response.data,
                status: response.status,
            };
        } catch (error) {
            setModified?.(true);

            return {
                data: error?.response?.data,
                status: error?.response?.status,
            };
        }
    },
);
